module.exports = __webpack_public_path__ + "static/media/Getting Started.3e975793.svg";